import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import colors from "../../styles/colors";

export const PrimaryButton = styled(Button)({
  borderRadius: "30px",
  padding: "8px 70px",
  backgroundColor: colors.WaterBlue,
  color: colors.IceWhite,
  transition: "all .5s",

  "&:hover": {
    backgroundColor: colors.DarkerGray,
  },

  "&:disabled": {
    backgroundColor: colors.FogGray,
    color: colors.IceWhite,
  },
});
